import { Component } from '@angular/core';

@Component({
  selector: 'app-form-grid',
  template: `<div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
    <ng-content></ng-content>
  </div>`,
})
export class FormGridComponent {}
